export const dateRangeConst = {
  today: {
    id: 'today',
    label: 'Today',
  },
  currentMonth: {
    id: 'currentMonth',
    label: 'Current month',
  },
  currentQuarter: {
    id: 'currentQuarter',
    label: 'Current quarter',
  },
  currentYear: {
    id: 'currentYear',
    label: 'Current year',
  },
  last24Hours: {
    id: 'last24Hours',
    label: 'Last 24 hours',
  },
  last7days: {
    id: 'last7days',
    label: 'Last 7 days',
  },
  last28days: {
    id: 'last28days',
    label: 'Last 28 days',
  },
  last90days: {
    id: 'last90days',
    label: 'Last 90 days',
  },
  last365days: {
    id: 'last365days',
    label: 'Last 365 days',
  },
  lastMonthsOne: {
    id: 'lastMonthsOne',
  },
  lastMonthsTwo: {
    id: 'lastMonthsTwo',
  },
  lastMonthsThree: {
    id: 'lastMonthsThree',
  },
}
